import { PageResponse } from 'context/PaginatedItems/types/PaginatedItems';

export const paged = <T>(frames: T[], page: any, pageSize: any): PageResponse<T> => {
  const totalItems = frames.length;
  const totalPages = Math.max(1, Math.floor((totalItems - 1) / pageSize + 1));
  const sublistStartIndex = Math.min((page - 1) * pageSize, totalItems);
  const sublistEndIndex = Math.min(sublistStartIndex + pageSize, totalItems);

  return {
    items: frames.slice(sublistStartIndex, sublistEndIndex),
    totalElements: totalItems,
    page: page,
    totalPages: totalPages,
  };
};
